import type {
  DealerAutocompleteOptions,
  GlobalSearchApolloClient,
} from "@/components/Navigation/GlobalHeader/GlobalSearch/types";
import type {
  DealerUsersQuery,
  DealerUsersQueryVariables,
} from "@/gql/graphql";
import { DEALER_USERS } from "@/hooks/service/useDealerUsers";
import { executeGlobalSearchQuery } from "./executeGlobalSearchQuery";

export async function fetchDealers(
  client: GlobalSearchApolloClient,
  accountId: string,
  searchTerm: string,
  signal?: AbortSignal
): Promise<{ totalCount: number; items: DealerAutocompleteOptions[] }> {
  const data = await executeGlobalSearchQuery<
    DealerUsersQuery,
    DealerUsersQueryVariables
  >({
    client,
    query: DEALER_USERS,
    variables: { accountId },
    signal,
  });

  const dealers = data?.dealerUsers;

  const trimmedSearchTerm = searchTerm.toLowerCase().trim();

  const dealersWithMatchingSearchTerm = dealers?.filter(
    (dealer) =>
      dealer.firstName.toLowerCase().includes(trimmedSearchTerm) ||
      dealer.lastName.toLowerCase().includes(trimmedSearchTerm) ||
      dealer.email.toLowerCase().includes(trimmedSearchTerm) ||
      `${dealer.firstName.trim().toLowerCase()} ${dealer.lastName.trim().toLowerCase()}`.includes(
        trimmedSearchTerm
      )
  );

  return {
    totalCount: dealersWithMatchingSearchTerm?.length ?? 0,
    items:
      dealersWithMatchingSearchTerm?.map((dealer) => ({
        dealerId: dealer.id,
        dealerName: `${dealer.firstName} ${dealer.lastName}`,
        dealerEmail: dealer.email,
      })) ?? [],
  };
}
